module.exports = __webpack_public_path__ + "img/symbol_3.9d9e4c0d.png";